

import { useEffect } from 'react';
import whatsappIcon from "../../Assets/Images/whatsapp.png";



const HeroSection = ({ image, images = [], pageTitle }) => {
  const isCarousel = images.length > 1;

  useEffect(() => {
    const carouselElement = document.getElementById('heroCarousel');
    if (carouselElement && window.bootstrap) {
      new window.bootstrap.Carousel(carouselElement, {
        interval: 2000,
        ride: 'carousel',
        pause: false,
        touch: true,
      });
    }
  }, []);


  return (
    <div className="position-relative overflow-hidden hero-section">

      {isCarousel ? (
        <div
          id="heroCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-pause="false"
          data-bs-touch="true"
        >
          <div className="carousel-inner">
            {images.map((slide, index) => (
              <div
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                key={index}
              >
                <img
                  src={slide.image}
                  alt={`Slide ${index + 1}`}
                  className="w-100"
                />
                {(slide.textLine1 || slide.textLine2) && (
                  <div className="custom-caption">
                    <h1 className="text-white">
                      {slide.textLine1 && <>{slide.textLine1}<br /></>}
                      {slide.textLine2}
                    </h1>
                  </div>
                )}

              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
          </button>
        </div>
      ) : (
        <img
          src={image || (images[0]?.image ?? "")}
          alt="Hero Background"
          className="w-100"
        />
      )}

      {pageTitle && (
        <div className="position-absolute top-50 start-50 translate-middle text-center">
          <h1 className="text-white fw-normal text-shadow">{pageTitle}</h1>
        </div>
      )}

      <div
        className="position-fixed bottom-0 end-0 pe-lg-3 pb-lg-2 text-end"
        style={{ zIndex: 1050 }}
      >
        <a
          href="https://api.whatsapp.com/send?phone=917039370147&text=samsevent"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={whatsappIcon}
            alt="WhatsApp"
            className="img-fluid whatsapp-icon"
          />
        </a>
      </div>
    </div>
  );
};

export default HeroSection;



